/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCurrencyItemRequestBuilder, WithCurrencyItemRequestBuilderNavigationMetadata, WithCurrencyItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /debtforecasts
 */
export interface DebtforecastsRequestBuilder extends BaseRequestBuilder<DebtforecastsRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.debtforecasts.item collection
     * @param currencyId Unique identifier of the item
     * @returns {WithCurrencyItemRequestBuilder}
     */
     byCurrencyId(currencyId: string) : WithCurrencyItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DebtforecastsRequestBuilderUriTemplate = "{+baseurl}/debtforecasts";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DebtforecastsRequestBuilderNavigationMetadata: Record<Exclude<keyof DebtforecastsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCurrencyId: {
        requestsMetadata: WithCurrencyItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithCurrencyItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["currencyId"],
    },
};
/* tslint:enable */
/* eslint-enable */
